export default __webpack_public_path__ + "static/media/bombeo_solar_10.1985780c.png";